import React from 'react';
import { pieceImage, pieceNames, hidden } from '../constants/pieces';

export default function BattlePanel({ pendingBattle, onResolve }) {
  if (!pendingBattle) return null;

  const defenderPlayer = pendingBattle.attackerPlayer === "1" ? "2" : "1";

  return (
    <div className="battle-panel">
      <div className="battle-title">⚔ Battle!</div>
      <div className="battle-pieces">
        <div className="battle-piece">
          <img
            className={`player${pendingBattle.attackerPlayer}-background`}
            src={pieceImage[pendingBattle.attackerPiece]}
            alt={pendingBattle.attackerPiece}
          />
          <div>Player {pendingBattle.attackerPlayer}'s {pieceNames[pendingBattle.attackerPiece]}</div>
        </div>
        <div className="battle-vs">vs</div>
        <div className="battle-piece">
          <img
            className={`player${defenderPlayer}-background`}
            src={hidden}
            alt="hidden"
          />
          <div>Player {defenderPlayer}'s ???</div>
        </div>
      </div>
      <div className="battle-result">
        {pendingBattle.outcome === "attacker"
          ? `${pieceNames[pendingBattle.attackerPiece]} wins!`
          : pendingBattle.outcome === "defender"
          ? `${pieceNames[pendingBattle.attackerPiece]} was eliminated!`
          : "Both pieces eliminated!"}
      </div>
      <button onClick={onResolve}>Continue</button>
    </div>
  );
}
